export default __webpack_public_path__ + "static/media/loading.e8fcceac.gif";